function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import BigNumber from "bignumber.js";
import { sortBy, zipObject } from "lodash";
import { getFullScope } from "./getFullScope";
import { lookup } from "./lookup";
import { roundNumber } from "./roundNumber";
import { inferType } from "./inferType";
var DECIMAL_UNITS = {
  "0": "unit",
  "1": "ten",
  "2": "hundred",
  "3": "thousand",
  "6": "million",
  "9": "billion",
  "12": "trillion",
  "15": "quadrillion",
  "-1": "deci",
  "-2": "centi",
  "-3": "mili",
  "-6": "micro",
  "-9": "nano",
  "-12": "pico",
  "-15": "femto"
};
var INVERTED_DECIMAL_UNITS = zipObject(Object.values(DECIMAL_UNITS), Object.keys(DECIMAL_UNITS).map(function (key) {
  return parseInt(key, 10);
}));
export function numberToHuman(i18n, input, options) {
  var roundOptions = {
    roundMode: options.roundMode,
    precision: options.precision,
    significant: options.significant
  };
  var units;

  if (inferType(options.units) === "string") {
    var scope = options.units;
    units = lookup(i18n, scope);

    if (!units) {
      throw new Error("The scope \"".concat(i18n.locale).concat(i18n.defaultSeparator).concat(getFullScope(i18n, scope, {}), "\" couldn't be found"));
    }
  } else {
    units = options.units;
  }

  var formattedNumber = roundNumber(new BigNumber(input), roundOptions);

  var unitExponents = function unitExponents(units) {
    return sortBy(Object.keys(units).map(function (name) {
      return INVERTED_DECIMAL_UNITS[name];
    }), function (numeric) {
      return numeric * -1;
    });
  };

  var calculateExponent = function calculateExponent(num, units) {
    var exponent = num.isZero() ? 0 : Math.floor(Math.log10(num.abs().toNumber()));
    return unitExponents(units).find(function (exp) {
      return exponent >= exp;
    }) || 0;
  };

  var determineUnit = function determineUnit(units, exponent) {
    var expName = DECIMAL_UNITS[exponent.toString()];
    return units[expName] || "";
  };

  var exponent = calculateExponent(new BigNumber(formattedNumber), units);
  var unit = determineUnit(units, exponent);
  formattedNumber = roundNumber(new BigNumber(formattedNumber).div(Math.pow(10, exponent)), roundOptions);

  if (options.stripInsignificantZeros) {
    var _formattedNumber$spli = formattedNumber.split("."),
        _formattedNumber$spli2 = _slicedToArray(_formattedNumber$spli, 2),
        whole = _formattedNumber$spli2[0],
        significand = _formattedNumber$spli2[1];

    significand = (significand || "").replace(/0+$/, "");
    formattedNumber = whole;

    if (significand) {
      formattedNumber += "".concat(options.separator).concat(significand);
    }
  }

  return options.format.replace("%n", formattedNumber || "0").replace("%u", unit).trim();
}